type TranslateFn = (key: string) => string;

export const getMissingPasswordRequirementMessages = (password: string, t: TranslateFn) => {
  const value = password || "";
  const messages: string[] = [];

  if (value.length < 8) {
    messages.push(t("components.passwordRequirements.minLength"));
  }

  if (!/[A-Za-z]/.test(value)) {
    messages.push(t("components.passwordRequirements.letter"));
  }

  if (!/\d/.test(value)) {
    messages.push(t("components.passwordRequirements.number"));
  }

  if (!/[^A-Za-z0-9]/.test(value)) {
    messages.push(t("components.passwordRequirements.specialCharacter"));
  }

  return messages;
};

export const isPasswordRequirementMessage = (message: string) => {
  const normalizedMessage = message
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  return (
    normalizedMessage.includes("a senha deve") ||
    normalizedMessage.includes("password must") ||
    normalizedMessage.includes("caractere especial") ||
    normalizedMessage.includes("special character")
  );
};
